module.exports = __webpack_public_path__ + "static/media/7B.75379c2a.png";